//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconRatingVerySadAlt(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M7.5 11.75C8.4665 11.75 9.25 10.9665 9.25 10C9.25 9.0335 8.4665 8.25 7.5 8.25C6.5335 8.25 5.75 9.0335 5.75 10C5.75 10.9665 6.5335 11.75 7.5 11.75Z" fill="currentColor" /><path d="M16.5 11.75C17.4665 11.75 18.25 10.9665 18.25 10C18.25 9.0335 17.4665 8.25 16.5 8.25C15.5335 8.25 14.75 9.0335 14.75 10C14.75 10.9665 15.5335 11.75 16.5 11.75Z" fill="currentColor" /><path d="M12.0002 13C8.93018 13 6.36018 15.13 5.68018 18H18.3202C17.6402 15.13 15.0702 13 12.0002 13Z" fill="currentColor" /></svg>;
}
export default IconRatingVerySadAlt;